import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatErr } from "@/lib/api";
import { BRAND } from "@/data/site";
import { Loader2, LogIn } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const next = params.get("next") || null;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      if (next) navigate(next);
      else if (u.role === "customer") navigate("/me/bookings");
      else if (u.role === "contractor") navigate("/contractor");
      else navigate("/admin");
    } catch (e) {
      setError(formatErr(e?.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="min-h-screen flex items-center justify-center px-5 py-20">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 mb-8 justify-center">
          <img src={BRAND.logoUrl} alt="" className="h-14 w-14 object-contain"/>
          <div>
            <div className="font-display uppercase text-xl text-[#F0F4F1] tracking-wider">Green Connect</div>
            <div className="font-display uppercase text-[10px] tracking-[0.3em] text-[#8DE038]">Sign in</div>
          </div>
        </Link>
        <form onSubmit={submit} className="border border-[#1F3325] bg-[#0F1712] p-8 md:p-10 space-y-5" data-testid="login-form">
          <h1 className="font-display uppercase text-3xl tracking-tighter text-[#F0F4F1] heading-accent">Welcome back</h1>
          <div>
            <label className="font-display uppercase tracking-widest text-xs text-[#9CAEA3]">Email</label>
            <input data-testid="login-email" required type="email" className="gl-input mt-2" value={email} onChange={(e)=>setEmail(e.target.value)} autoFocus/>
          </div>
          <div>
            <label className="font-display uppercase tracking-widest text-xs text-[#9CAEA3]">Password</label>
            <input data-testid="login-password" required type="password" className="gl-input mt-2" value={password} onChange={(e)=>setPassword(e.target.value)}/>
          </div>
          {error && <div data-testid="login-error" className="text-red-400 text-sm border border-red-500/40 bg-red-900/20 p-3">{error}</div>}
          <button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60">
            {loading ? <Loader2 className="animate-spin" size={18}/> : <><LogIn size={16}/> Sign in</>}
          </button>
          <div className="text-center text-sm text-[#9CAEA3]">
            New to Green Connect? <Link to="/register" className="text-[#8DE038] font-display uppercase tracking-widest text-xs">Create account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
